export const msalConfig = {
  auth: {
    clientId: "8d657183-faec-44e2-b200-d3f44b075e3f", // Replace with your actual client ID from Microsoft Entra ID
    authority:
      "https://login.microsoftonline.com/985840b1-9bbf-4f13-b5ae-9e9394b9f34e",
    redirectUri:
      process.env.REACT_APP_REDIRECT_URI ||
      (process.env.NODE_ENV === "production"
        ? "https://card.viu.ch" // Fallback production URL
        : "https://localhost:3000"), // Development URL
  },
  cache: {
    cacheLocation: "localStorage", // Use localStorage for persistent login
    storeAuthStateInCookie: true, // Enable cookies as fallback for mobile browsers
  },
  system: {
    // Configure token refresh settings
    tokenRenewalOffsetSeconds: 300, // Refresh token 5 minutes before expiry
    navigateToLoginRequestUrl: false, // Don't navigate to login URL after redirect
    allowNativeBroker: false, // Disable native broker for web apps
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [
    "User.Read",
    "User.ReadBasic.All",
    "People.Read",
    "Contacts.Read",
    "offline_access",
  ],
  // Remove prompt: "login" to allow token caching
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphPhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value",
};

// Silent request configuration for checking existing tokens
export const silentRequest = {
  scopes: ["User.Read", "offline_access"],
  forceRefresh: false,
  redirectUri:
    process.env.REACT_APP_REDIRECT_URI ||
    (process.env.NODE_ENV === "production"
      ? "https://card.viu.ch"
      : "https://localhost:3000"),
};
